/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from '../../registry/Component.type';
import { data } from './SampleCSVData';

export const page: {
  root: Item<'Page'>;
  flexPanel: Item<'FlexPanel'>;
  flexItem: Item<'FlexItem'>;
  flexItem1: Item<'FlexItem'>;
  smartSearch: Item<'SmartSearch'>;
  localDataStore: Item<'LocalDataStore'>;
  dataStoreReference: Item<'DataStoreReference'>;
  dataGrid: Item<'DataGrid'>;
  stringColumn: Item<'StringColumn'>;
  dateColumn: Item<'DateColumn'>;
  numberColumn: Item<'NumberColumn'>;
  checkboxColumn: Item<'CheckboxColumn'>;
  dateColumn1: Item<'DateColumn'>;
  checkboxColumn1: Item<'CheckboxColumn'>;
  smartSearchAttribute: Item<'SmartSearchAttribute'>;
  smartSearchAttribute1: Item<'SmartSearchAttribute'>;
  smartSearchAttribute2: Item<'SmartSearchAttribute'>;
  smartSearchAttribute3: Item<'SmartSearchAttribute'>;
  smartSearchAttribute4: Item<'SmartSearchAttribute'>;
  smartSearchAttribute5: Item<'SmartSearchAttribute'>;
} = {
  checkboxColumn: {
    children: [],
    itemId: 'checkboxColumn',
    parent: 'dataGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Active' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'active',
      width: 105,
    },
    type: 'CheckboxColumn',
  },
  checkboxColumn1: {
    children: [],
    itemId: 'checkboxColumn1',
    parent: 'dataGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Some YN' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'someYn',
      width: 80,
    },
    type: 'CheckboxColumn',
  },
  dataGrid: {
    children: [
      'stringColumn',
      'dateColumn',
      'numberColumn',
      'checkboxColumn',
      'dateColumn1',
      'checkboxColumn1',
    ],
    itemId: 'dataGrid',
    parent: 'flexItem1',
    props: {},
    type: 'DataGrid',
  },
  dataStoreReference: {
    children: ['flexPanel'],
    itemId: 'dataStoreReference',
    parent: 'root',
    props: {
      alias: 'alias',
    },
    type: 'DataStoreReference',
  },
  dateColumn: {
    children: [],
    itemId: 'dateColumn',
    parent: 'dataGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Some Date' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'someDate',
      width: 144,
    },
    type: 'DateColumn',
  },
  dateColumn1: {
    children: [],
    itemId: 'dateColumn1',
    parent: 'dataGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Some Date Time' },
      showTime: true,
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'someDateTime',
      width: 220,
    },
    type: 'DateColumn',
  },
  flexItem: {
    children: ['smartSearch'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {
      sizeType: 'auto',
    },
    type: 'FlexItem',
  },
  flexItem1: {
    children: ['dataGrid'],
    itemId: 'flexItem1',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem', 'flexItem1'],
    itemId: 'flexPanel',
    parent: 'dataStoreReference',
    props: {
      gridGap: 8,
    },
    type: 'FlexPanel',
  },
  localDataStore: {
    children: [],
    itemId: 'localDataStore',
    parent: 'root',
    props: {
      alias: 'alias',
      data,
      dataSource: 'ds',
    },
    type: 'LocalDataStore',
  },
  numberColumn: {
    children: [],
    itemId: 'numberColumn',
    parent: 'dataGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Some Number' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'someNumber',
      width: 148,
    },
    type: 'NumberColumn',
  },
  root: {
    children: ['localDataStore', 'dataStoreReference'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
  smartSearch: {
    children: [
      'smartSearchAttribute',
      'smartSearchAttribute1',
      'smartSearchAttribute2',
      'smartSearchAttribute3',
      'smartSearchAttribute4',
      'smartSearchAttribute5',
    ],
    itemId: 'smartSearch',
    parent: 'flexItem',
    props: {},
    type: 'SmartSearch',
  },
  smartSearchAttribute: {
    children: [],
    itemId: 'smartSearchAttribute',
    parent: 'smartSearch',
    props: {
      attributeCode: 'name',
      defaultOperator: 'is',
      label: 'Name',
    },
    type: 'SmartSearchAttribute',
  },
  smartSearchAttribute1: {
    children: [],
    itemId: 'smartSearchAttribute1',
    parent: 'smartSearch',
    props: {
      attributeCode: 'someDate',
      dataType: 'Date',
      defaultOperator: 'after',
      label: 'Some Date',
    },
    type: 'SmartSearchAttribute',
  },
  smartSearchAttribute2: {
    children: [],
    itemId: 'smartSearchAttribute2',
    parent: 'smartSearch',
    props: {
      attributeCode: 'someNumber',
      dataType: 'Number',
      defaultOperator: 'eq',
      label: 'Some Number',
    },
    type: 'SmartSearchAttribute',
  },
  smartSearchAttribute3: {
    children: [],
    itemId: 'smartSearchAttribute3',
    parent: 'smartSearch',
    props: {
      attributeCode: 'active',
      dataType: 'Boolean',
      defaultOperator: 'isTrue',
      label: 'Active',
    },
    type: 'SmartSearchAttribute',
  },
  smartSearchAttribute4: {
    children: [],
    itemId: 'smartSearchAttribute4',
    parent: 'smartSearch',
    props: {
      attributeCode: 'someDateTime',
      dataType: 'Date',
      defaultOperator: 'after',
      label: 'Some Date Time',
    },
    type: 'SmartSearchAttribute',
  },
  smartSearchAttribute5: {
    children: [],
    itemId: 'smartSearchAttribute5',
    parent: 'smartSearch',
    props: {
      attributeCode: 'someYn',
      dataType: 'YN',
      defaultOperator: 'is',
      label: 'Some YN',
    },
    type: 'SmartSearchAttribute',
  },
  stringColumn: {
    children: [],
    itemId: 'stringColumn',
    parent: 'dataGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Name' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'name',
      width: 200,
    },
    type: 'StringColumn',
  },
};
